// extracted by mini-css-extract-plugin
export default {"mailListLoading":"zqrqv","mailListHeader":"YyYjM","adBannerContainer":"rsdsd"};